<template>
  <div class="col-lg-10 col-md-12 mx-auto">
    <!-- <b-toast
      variant="secondary"
      id="attivato-abb"
      title="Attivato!"
      static
      no-close-button
      class="text-center mx-auto"
      body-class="text-gray-dark"
    >
      <p class="text-justify mx-auto mb-0">Abbonamento attivato</p>
    </b-toast>-->
    <h3>Lista Abbonamenti</h3>
    <!-- <div class="col-12 mx-auto">
      <b-form-select v-model="only" :options="filters" @change="getUsers"></b-form-select>
    </div>-->
    <div class="col-12 mx-auto d-flex font-weight-bold mt-3">
      <span class="ml-0 mr-auto col-1">Id Prodotto</span>
      <span class="ml-0 mr-auto col-3">Nome</span>
      <span class="ml-0 mr-auto col-3">Descrizione</span>
      <span class="ml-0 mr-auto col-1">Durata (mesi)</span>
      <span class="ml-0 mr-auto col-1">Prezzo</span>
      <span class="ml-0 mr-auto col-1">Stato</span>
      <span class="ml-0 mr-auto col-2"></span>
    </div>
    <div
      class="col-12 d-flex align-items-center no-wrap mx-auto my-2"
      v-for="(abbonamento,ind) in abbonamenti"
      :key="ind"
    >
      <span
        class="text-center text-secondary font-weight-bold col-1 ml-0 mr-auto"
      >{{abbonamento.wc_product_id && abbonamento.wc_product_id }}</span>
      <span
        class="text-center text-secondary font-weight-bold col-3 ml-0 mr-auto"
      >{{abbonamento.slug}}</span>
      <span
        class="text-center text-secondary font-weight-bold col-3 ml-0 mr-auto"
      >{{abbonamento.descrizione}}</span>
      <span
        class="text-center text-secondary font-weight-bold col-1 ml-0 mr-auto"
      >{{abbonamento.durata }}</span>
      <span
        class="text-center text-secondary font-weight-bold col-1 ml-0 mr-auto"
      >{{abbonamento.prezzo}}</span>
      <span
        class="text-center text-secondary font-weight-bold col-1 ml-0 mr-auto"
      >{{abbonamento.attivo ? 'attivo' : 'non attivo' }}</span>

      <div class="col-2 mx-auto">
        <b-button class="col" variant="secondary" @click="showModal(abbonamento)">Modifica</b-button>
      </div>
    </div>
    <b-modal
      ref="dettaglio_abb"
      size="xl"
      title="Dettagli Abbonamento"
      scrollable
      centered
      header-bg-variant="secondary"
      header-text-variant="white font-weight-bold"
      cancel-disabled
      ok-disabled
      ok-only
    >
      <dettaglio-abbonamento :item="selected" v-on:close-modale="closeModal" :servizi="servizi" />
    </b-modal>
  </div>
</template>
<script>
import DettaglioAbbonamento from "@/components/admin/DettaglioAbbonamento";
export default {
  name: "ListaAbbonamenti",
  components: { DettaglioAbbonamento },
  data() {
    return {
      servizi: null,
      abbonamenti: null,
      selected: null
    };
  },
  methods: {
    getAbbonamenti() {
      var url = process.env.VUE_APP_VERSION + "admin/abbonamenti";
      this.$axios
        .get(url)
        .then(res => {
          console.log(res.data.data);
          this.abbonamenti = res.data.data;
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    getServizi() {
      var url = process.env.VUE_APP_VERSION + "admin/servizi";
      this.$axios
        .get(url)
        .then(res => {
          console.log(res.data.data);
          this.servizi = res.data.data;
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    showModal(rif) {
      this.selected = rif;
      console.log(this.selected);
      this.$refs["dettaglio_abb"].show();
    },
    closeModal() {
      this.selected = null;
      this.$refs["dettaglio_abb"].hide();
    }
  },
  created() {
    this.getAbbonamenti();
    this.getServizi();
  }
};
</script>